module.exports = __webpack_public_path__ + "static/media/check-mark.5288ce17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check-mark.svg
// module id = 2104
// module chunks = 33